export default {
  common: {
    pageprev: "Prev",
    pagenext: "Next",
    home: "Home",
    services: "Services",
    advantage: "Advantages",
    news: "News",
    about: "About Us",
    contact: "Contact Us",
    loading: "Loading...",
    noData: "No Data",
    language: "Language",
    chinese: "中文",
    english: "English",
    nopic: "No Picture",
    fenxiang: "Share to :",
    kefuQrcode: "Customer Service",
    websiteQrcode: "Website",
    kefuHotline: "Hotline",
    kefuEmail: "Email",
    companyAddress: "Address",
    backTop: "Top",
  },
  banner: {
    title: "Creative Tech",
    subtitle: "Professional Services, Professional Solutions",
    btnText: "Contact Us"
  },
  index:{
    whyChooseUs: "Why Choose Us",
    whoAreWe: "Focus on Social Media Marketing",
    whoAreWeen: "What do we do?",
    zixun: "Contact Us",
    appWechat: "Wechat",
    appinstagram: "Instagram",
    apptiktok: "Tiktok",
    appweibo: "WeiBo",
    appxiaohongshu: "Xiaohongshu",
    appfacebook: "Facebook",
    appdouyin: "Douyin",
    apppath: "Path",
    applinkedin: "LinkedIn",
    appyoutube: "YouTube",
    appx: "Twitter",
    appshipinhao: "Video",
    appzhihu: "Zhihu",
    apptoutiao: "Toutiao",
    appkuaishou: "Kuaishou",
    appPinterest: "Pinterest",
    qudaoup:"Our Marketing Channels",
    qudaomain:"Cover mainstream social media platforms at home and abroad",
    qudaomainen:"",
    qudaosmy:"We deeply integrate global high‑traffic social platforms, precisely reach users across all segments at home and abroad, and achieve full‑scale diffusion of brand influence and efficient conversion.",
  },
  news: {
    detail: "News Detail",
    publishTime: "Publish Time",
    readMore: "Read More",
    loading: "Loading...",
    noData: "No news data",
    weizhi: "Your Location",
    shouye: "Home",
    xinwen: "News",
    newsClass: "News Class",
    allNews: "All News",
    wushuju: "No data available",
    hotNews: "Hot News",
    shijian: "Publish Time",
  },
  contact: {
    leaveMessage: "Leave a Message",
    title: "Contact Us",
    name: "Name",
    namePlaceholder: "Please enter your name",
    email: "Email",
    emailPlaceholder: "Please enter your email",
    phone: "Phone",
    phonePlaceholder: "Please enter your phone number",
    message: "Message",
    messagePlaceholder: "Please enter your message",
    submit: "Submit",
    submitSuccess: "Submit Successful",
    submitError: "Submit Failed",
    loading:"Loading..."
  },
  about: {
    kehu: "Our Clients",
    kehuen: "",
  },
  contactus: {
    wechat: 'WeChat',
    phone: 'Phone',
    wechatQrAlt: 'WeChat QR Code',
    wechatTip: 'Scan to add customer service',
    phoneTip: 'Click to dial directly',
    qrError: 'QR Code load failed',
    tel:'(+61) 426384498'
  },
  title: {
    home: "Home - Creative Tech",
    newsList: "News List - Creative Tech",
    newsDetail: "News Detail - Creative Tech"
  },
  nav: {
    home: "Home",
    news: "News",
    about: "About",
    contact: "Contact",
    service: "Services",
  }
};